import { CLEAR_USER, SET_LOADING, SET_USER } from "../actions/types";

const initialUser = {
  currentUser: null,
  isLoading: true,
};

//Handling User
export const userReducer = (state = initialUser, { type, payload }) => {
  switch (type) {
    case SET_USER:
      return {
        currentUser: payload.currentUser,
        isLoading: false,
      };
    case CLEAR_USER:
      return {
        ...state,
        isLoading: false,
      };
    case SET_LOADING:
      return {
        ...state,
        isLoading: payload.loading,
      };
    default:
      return state;
  }
};
